import { UIComponentState, UIDataModel, UIComponentHandler } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { HomeViewImpl } from './homeview';
import { HomeCSSStyleImpl } from './homecss';
import { FeaturedCategoryDto } from '../../../../core/dto/featuredcategory/featuredcategorydto';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { HomeAPIModelImpl, HomeAPIModel } from './homeapimodel';
import { BannerDto } from '../../../../core/dto/banner/bannerdto';
import { CRBTUIComponent, CRBTUIComponentProps } from '../crbt/crbtuicomponent';
import { RoutingFeatures } from '../../navigation/routingfeature';
import { LoginDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/login/logindto';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { CreateAccountDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/createaccount/createaccountdto';
import { AESEncryptionDecryption } from 'src/com/sixdee/crbtportal/utils/aseencryption';

export interface HomeComponentProps extends CRBTUIComponentProps
{
    onBannerClick(bannerDto: BannerDto): void;
}

export interface HomeComponentState extends UIComponentState
{
    isConfiguartionLoaded: boolean;
    // listOfFeaturedCategories: FeaturedCategoryDto[];
    listOfBannerDtos: BannerDto[];
    // subscriptionPlanDetailsDto: SubscriptionPlanDetailsDto;
    queriedMsisdn: string;
}

export interface HomeComponentHandler extends UIComponentHandler
{
    onSearchClick(searchKey: string):void;
    onSpecificSearchClick(searchKey:string,type:string):void;
    loadMoreFeaturedCategoryTones(featuredCategoryDto: FeaturedCategoryDto, startIndex: number, offset: number): void;
}

export class HomeComponent extends CRBTUIComponent<HomeComponentProps, HomeComponentState> 
implements HomeComponentHandler
{
    constructor(props: HomeComponentProps)
    {
        super(props);
         console.log("home component invoked&&&&&");
        this.state = {isConfiguartionLoaded: false,
             queriedMsisdn: "",listOfBannerDtos: []};

    }

    
    UNSAFE_componentWillMount()
    {
        super.UNSAFE_componentWillMount();
        if(!this.props.context.getUserContext().getIsLoggedIn())
        {
            history.pushState(null, location.href);
                window.onpopstate = function () {
                    history.go(1);
                };
        }

        console.log("this.props.context.getUserContext().getMsisdn(): " + this.props.context.getUserContext().getMsisdn());
        console.log("msisdn "+this.props.context.getUserContext().getMsisdn(),"Login type:"+this.props.context.getUserContext().getLoginType,"toneId:",this.props.context.getUserContext().getToneId());
        
        if(this.props.context.getUserContext().getMsisdn() === "")
        {
                console.log("Calling Ayoba...... ");
                    var ayobaObj = require("../../../../../../../../node_modules/ayoba-microapp-api/index.js");
                    ayobaObj.getUserPhoneNumber((ayobaMsisdn:string)=>{
                    ayobaMsisdn = ayobaMsisdn.replace(this.props.context.
                        getResources().getString(Strings.countrycode),"");
                    this.setState({queriedMsisdn: ayobaMsisdn});
                    
                    console.log("MSISDN received from Ayoba :",ayobaMsisdn);
                    let request = new LoginDtoImpl();
                        request.setMsisdn(ayobaMsisdn);
                        request.setPassword("Oem@L#@1");
                        this.getAPIModel().validateSubscriber(request);
                    },()=>{
                        console.log("Ayoba Failed to fetch MSISDN :");

                    let urlSearchParams = new URLSearchParams(window.location.search);
                    let queriedMsisdn = urlSearchParams.get("token");
            // msisdn u7RuM5yvmbk1bWye3LE9ng==
            //key mofSSBh+ys/nwHn8EBmXgg==

            if(queriedMsisdn !== "" && queriedMsisdn !== null && queriedMsisdn !== undefined)
            {

                console.log("Token Recieved from HE integration: " , queriedMsisdn);

                queriedMsisdn = queriedMsisdn.replace(/ /g,"+");
                console.log("Replaced All spaces", queriedMsisdn);

                let decryptedData = AESEncryptionDecryption.decryptWithAESSha1(queriedMsisdn, 
                           "mofSSBh+ys/nwHn8EBmXgg==");
                console.log("Decrypted data: " + decryptedData);
                //HE integration
              
                this.setState({queriedMsisdn: decryptedData});
                let request = new LoginDtoImpl();
                    request.setMsisdn(decryptedData);
                    request.setPassword("Oem@L#@1");
                    this.getAPIModel().validateSubscriber(request);
            }
            else
            {
              
                 console.log("Non-loggedin Flow ");
                this.getAPIModel().getSettings();  
            }
        });
        }
      
        else
        {
            this.getAPIModel().getSettings();
            console.log("Non-loggedin Flow ");  
        }
    }


    componentDidMount()
    {        
        window.scrollTo(0,0);
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new HomeViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new HomeCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new HomeAPIModelImpl(applicationContext, apiModelHandler);
    }

    loadMoreFeaturedCategoryTones(featuredCategoryDto: FeaturedCategoryDto, startIndex: number, offset: number): void 
    {
        // this.getAPIModel().getLoadMoreFeatureCategoriesTones(featuredCategoryDto, startIndex, offset);
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        console.log("----------feature: " + feature + ", =======data: " + data);

        if(feature === APIFeatures.SETTINGS)
        {
            this.setState({isConfiguartionLoaded: true});
            
            this.getAPIModel().getBanners();
            // this.getAPIModel().getSubscriptionPlanDetails();
        }
        else if(feature === APIFeatures.PASSWORD_VALIDATION)
        {
            window.location.reload();
        }
       
        else if(feature === APIFeatures.SUBSCRIBER_VALIDATION && 
            description === this.getContext().getResources().getString(Strings.valid_subscriber))
        {
            let request = new LoginDtoImpl();
            request.setMsisdn(this.state.queriedMsisdn);
            request.setPassword("Oem@L#@1");
            this.getAPIModel().doLogin(request);
            
        }
        else if(feature === APIFeatures.CREATE_ACCOUNT)
        {
            let request = new LoginDtoImpl();
            request.setMsisdn(this.state.queriedMsisdn);
            request.setPassword("Oem@L#@1");
            this.getAPIModel().doLogin(request);
        }
        else if(feature === APIFeatures.SECURITY_TOKEN)
        {
            let request = new CreateAccountDtoImpl();
            request.setMsisdn(this.state.queriedMsisdn);
            request.setEmail("");
            request.setLanguage(this.props.context.getUserContext().getLanguage());
            request.setPassword("Oem@L#@1");
            request.setCategoryId("4");

            this.getAPIModel().createAccount(request, data);
        }
        else if(feature === APIFeatures.BANNER)
        {
            this.setState({listOfBannerDtos: (data as BannerDto[])});     
        }
        else if(feature === APIFeatures.SUBSCRIPTION_PLAN_DETAILS)
        {
            // this.setState({subscriptionPlanDetailsDto:data as SubscriptionPlanDetailsDto});
        }

        window.scrollTo(0,0);
    }

    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        console.log("--onFailure-: " + feature + "----description-----" + description);

        if(feature === APIFeatures.SECURITY_TOKEN || feature === APIFeatures.PASSWORD_VALIDATION &&
            feature === APIFeatures.CREATE_ACCOUNT)
        {
            this.getAPIModel().getSettings();
        }
        else if(feature === APIFeatures.SUBSCRIBER_VALIDATION)
        {   
            if(description === this.getContext().getResources().getString(Strings.subscriber_not_registered))
            {
                this.getAPIModel().getSecurityCounter();
            }
            else
            {
                this.getAPIModel().getSettings();
            }
        }
    }

    onSearchClick(searchKey: string):void
    {
        searchKey = searchKey.trim();
        this.props.routeNextFeature(RoutingFeatures.NAME_TUNES + "?searchkey=" + searchKey, false);

    }

    onSpecificSearchClick(searchKey:string, type:string):void
    {
        searchKey = searchKey.trim();
        this.props.routeNextFeature(RoutingFeatures.SEARCH_LIST + "?searchkey=" + searchKey + "&type=" + type, false);
    }
    getAPIModel(): HomeAPIModel
    {
        return (super.getAPIModel() as HomeAPIModel);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/home/homecomponent.tsx